import { useEffect, useRef, type JSX } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { assessGameState } from "./homeSlice"

export const Timer = (): JSX.Element | null => {
  const homeSlice = useAppSelector(state => state.home)
  const dispatch = useAppDispatch()
  const count = useRef(0)

  //   const [ellapsedTime, setEllapsedTime] = useState(0)
  //   const startTimeRef = useRef(homeSlice.startTime)

  // reevaluate game time with every browser repaint
  useEffect(() => {
    let frameId: number

    const tick = () => {
      count.current += 1
      if (count.current % 10 === 0) {
        dispatch(assessGameState(Date.now()))
        //   setEllapsedTime((Date.now() - homeSlice.startTime) / 1000)
      }
      frameId = requestAnimationFrame(tick)
    }

    // if (homeSlice.gameState === "running") {
    frameId = requestAnimationFrame(tick)
    // }

    return () => {
      cancelAnimationFrame(frameId)
    }
  }, [])

  // TODO: maybe use logic here to not rerender time if pauseTime is not undefined,
  // instead of adding rest value to pauseSum in homeSlice. second ellapsedTime as useState needed
  return <div>{Math.max(0, homeSlice.timeMode - homeSlice.ellapsedTime).toFixed(2)}</div>
}
